module.exports = __webpack_public_path__ + "48cf10ad493787d58cb22a955aa3ae2c.jpg";